import React, { useEffect, useState } from "react";
import { autoWebViewJs } from "@droid/android";
import { Room } from "matrix-js-sdk";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Box,
    Avatar,
    Typography,
    Snackbar
} from '@mui/material';

interface CreateShortcutDialogProps {
  room: Room;
  onClose: () => void;
}

const CreateShortcutDialog: React.FC<CreateShortcutDialogProps> = ({ room, onClose }) => {
  const [shortcutName, setShortcutName] = useState(room.name || '会议室');
  const [icon, setIcon] = useState<string | null>(null);
  // 使用 Snackbar 来显示消息
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    const handleIconSelected = (event: CustomEvent) => {
      const { base64 } = event.detail;
      if (base64) {
        setIcon(`data:image/png;base64,${base64}`);
      }
    };
    window.addEventListener('native.iconSelected', handleIconSelected as EventListener);
    return () => {
      window.removeEventListener('native.iconSelected', handleIconSelected as EventListener);
    };
  }, []);

  const handleSelectIconClick = () => {
    const script = `com.fanfanlo.emergencycall.manager.NativeImagePicker.selectIcon();`;
    autoWebViewJs.callScript(script);
  };

  const handleConfirm = () => {
    const iconBase64Data = icon ? icon.split(',')[1] : '';
    const sanitizedName = shortcutName.replace(/'/g, "\\'");
    const script = `com.fanfanlo.emergencycall.manager.ShortcutManager.createConferenceShortcut('${room.roomId}', '${sanitizedName}', '${iconBase64Data}');`;
    const { javaResultString } = autoWebViewJs.callScript(script);
    if (javaResultString === 'true') {
      setMessage('快捷方式创建成功！');
      setTimeout(onClose, 1500);
    } else {
      setMessage('创建失败，请检查权限或重试。');
    }
  };

  return (
    <>
      <Dialog open={true} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle>创建会议快捷方式</DialogTitle>
        <DialogContent dividers>
          <TextField
            autoFocus
            margin="dense"
            label="快捷方式名称"
            type="text"
            fullWidth
            variant="outlined"
            value={shortcutName}
            onChange={(e) => setShortcutName(e.target.value)}
          />
          <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
            <Typography variant="body1">图标:</Typography>
            <Avatar 
              src={icon || undefined} 
              sx={{ width: 56, height: 56 }}
            >
              {!icon && shortcutName.charAt(0)}
            </Avatar>
            <Button variant="outlined" onClick={handleSelectIconClick}>
              从相册选择
            </Button>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>取消</Button>
          <Button onClick={handleConfirm} variant="contained">
            确认创建
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={!!message}
        autoHideDuration={3000}
        onClose={() => setMessage(null)}
        message={message}
      />
    </>
  );
};
export default CreateShortcutDialog;

